import { AlgorithmFormDataType } from '../algorithms/schema/types';
import { AlgorithmType } from '../algorithms/schema/zAlgorithmType';

export const defaultAlgorithmFormData = (
  isInput: boolean,
  dataObjectDescriptionVersionId: number
): AlgorithmFormDataType => ({
  id: -1,
  typeCode: AlgorithmType.INSERT,
  dataObjectDescriptionVersionId,
  code: '',
  groupCode: '',
  sequenceNumber: 1,
  validPeriod: [null, null],
  statusId: undefined!,
  statusName: '',
  description: '',
  execAfterAggregation: null,
  aggregatePeriods: isInput ? null : true,
  expression: '',
  filterClause: '',
});
